import * as yup from "yup";

export const EMPValidationSchema = yup.object({
  mandantName: yup.string().required("Field is required"),
  actualEmps: yup.number().required("Field is required"),
  billingAddressAdditional: yup.string().notRequired(),
  billingAddressCity: yup.string().notRequired(),
  billingAddressCompanyName: yup.string().notRequired(),
  billingAddressCountry: yup.string().notRequired(),
  billingAddressHouseNumber: yup.string().notRequired(),
  billingAddressPostcode: yup.string().notRequired(),
  billingAddressStreet: yup.string().notRequired(),
  businessAddressAdditional: yup.string().notRequired(),
  businessAddressCity: yup.string().required("Field is required"),
  businessAddressCompanyName: yup.string().required("Field is required"),
  businessAddressCountry: yup.string().required("Field is required"),
  businessAddressHouseNumber: yup.string().notRequired(),
  businessAddressPostcode: yup.string().required("Field is required"),
  businessAddressStreet: yup.string().required("Field is required"),
  exemptFromElectricityTax: yup.boolean().required("Field is required"),
  exemptFromVat: yup.boolean().required("Field is required"),
  bic: yup.string().notRequired(),
  iban: yup
    .string()
    .matches(/^[A-Z0-9]+$/, "IBAN must not contain spaces")
    .required("Field is required"),
  email: yup
    .string()
    .email("Invalid email format")
    .required("Field is required"),
  invoiceEmail: yup
    .string()
    .email("Invalid email format")
    .required("Field is required"),
  invoiceLanguage: yup.string().required("Field is required"),
  firstName: yup.string().notRequired(),
  lastName: yup.string().notRequired(),
  notes: yup.string().notRequired(),
  phone: yup.string().notRequired(),
  taxId: yup.string().required("Field is required"),
  vatId: yup.string().optional(),
});
